import Calculator from './component/age';
import './App.css';

function App() {
  return (
    <div>
        <Calculator />
    </div>
    
  );
}

export default App;
